export function mongoIdToColor(mongoId) {
	let hash = 0;
	for (let i = 0; i < mongoId.length; i++) {
		hash = mongoId.charCodeAt(i) + ((hash << 5) - hash);
	}
	const hue = Math.abs(hash) % 360;
	const saturation = 50;
	const lightness = 50;

	return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}